import { Link, useParams } from 'react-router-dom';
import {
    useGiftCertificateQuery,
    useSubmissionQuery,
} from '../lib/PublicQueries';
import FormThankYou from '../components/FormThankYou';
import Loading from '../../components/Loading';
import ThemedForm from '../../components/forms/ThemedForm';
import PageContainer from '../components/PageContainer';
import FormBackgroundContainer from '../../components/forms/FormBackgroundContainer';
import { useSetCurrency } from '../../lib/CurrencyHelpers';
import ErrorMessage from '~/components/ErrorMessage';
import ThemedConfirmationContainer from '~/public/components/ThemedConfirmationContainer';
import PrintableGiftCertificate from '~/components/giftcertificates/PrintableGiftCertificate';
import { useEffect } from 'react';
import { useSetLocale } from '~/lib/useSetLocale.js';
import { BusinessProvider } from '~/lib/BusinessContext';

const GiftCertificateViewPage = ({}) => {
    const { token } = useParams();
    const { data, isLoading } = useGiftCertificateQuery(token);
    useSetLocale(data?.context);

    const isPrint = !!new URL(document.location.href).searchParams.get('print');
    const giftCertificate = data?.giftCertificate;

    useEffect(() => {
        if (isPrint && !!giftCertificate) {
            window.print();
        }
    }, [giftCertificate, isPrint]);

    if (isLoading) {
        return <Loading />;
    }

    if (!giftCertificate) {
        return (
            <div className="flex items-center justify-center text-red-600 my-8">
                Not found
            </div>
        );
    }
    return (
        <BusinessProvider business={data?.business}>
            <div className="flex flex-col items-center justify-center my-8">
                <PrintableGiftCertificate
                business={data?.business}
                recipient={giftCertificate.recipient}
                purchaserName={giftCertificate?.purchaser_name}
                value={giftCertificate.value}
                expires={giftCertificate.expires_at}
                message={giftCertificate.settings?.message || ''}
                image={giftCertificate.settings?.image || ''}
                code={giftCertificate.code?.code}
                remainingValue={giftCertificate.remaining_value}
                print={isPrint}
                className="w-[650px]"
            />

            {!isPrint && (
                <Link
                    to={document.location.href + '?print=true'}
                    className="text-center form-button no-underline mt-4"
                >
                    Print
                </Link>
            )}
            </div>
        </BusinessProvider>
    );
};

export default GiftCertificateViewPage;
